import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"15%"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "text-left font-semibold",
  style: {"width":"65%","word-break":"break-word"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "font-normal whitespace-normal" }
const _hoisted_6 = { class: "text-left font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_row_base = _resolveComponent("pdf-row-base")!

  return (_openBlock(), _createBlock(_component_pdf_row_base, null, {
    default: _withCtx(() => [
      _createElementVNode("td", _hoisted_1, [
        (_ctx.imgSrc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.imgSrc,
              class: "mt-0",
              style: {"height":"120px","width":"90px"}
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.customInputData.titel) + " ", 1),
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.customInputData.freitext), 1)
      ]),
      _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.customInputData.gewerk), 1)
    ]),
    _: 1
  }))
}